import { useCallback } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { UsePanelNuevoElemento } from "./UsePanelNuevoElemento";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { TextField } from "@fluentui/react";


export const PanelNuevoElemento=(props:IOpenPanel)=>{
    const {request,setRequest,postInsertarElemento,loading,disableForm,reset,mensaje,status} = UsePanelNuevoElemento(props)
    const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto="Guardar"
              texto2={"Salir"}
              disableButton={disableForm}
              onClick={postInsertarElemento}
              onDismiss={() => {
                 reset()
              }}
            />
          </>
        ),
        [disableForm,request]
      );
      return (
        <PanelDrawer isOpen={props.isOpen} onDismiss={reset} onRenderFooter={onRenderFooter}
        textHeader={"Agregar Nuevo Incidente"} status={status} mensaje={mensaje} loading={loading}>
        <TextField 
         type="text"
         label="Nombre de incidente"
         placeholder="Escribir aquí el nombre del incidente"
         autoComplete="off"
         value={request.nombreEstandar}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,nombreEstandar:newValue})}
         }}
         />

        </PanelDrawer>
      )


}